module.exports = __webpack_public_path__ + "img/pixabayLogo.2522bf85.png";